import Axios from "axios";
import React from "react";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { Spin } from "../loading";

interface InspectOverviewProps {}

interface State {
  barChart: unknown[];
  lineChart: unknown[];
  loading: boolean;
}

export const InspectOverview: React.FC<InspectOverviewProps> = (props) => {
  const [state, setState] = React.useState<State>({
    barChart: [],
    lineChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/inspect/overview`)
      .then((res) => {
        const { lineChart, barChart } = res.data;

        setState({
          ...state,
          lineChart: [{ data: lineChart[0], label: "Lantern" }, { data: lineChart[1], label: "Column" }],
          barChart: [{ data: barChart[0], label: "Lantern" }, { data: barChart[1], label: "Column" }],
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">inspect overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}

        <div style={{ width: "100%", height: "300px" }}>
          <Spin spin={state.loading}>
            <LineChart data={state.lineChart} />
          </Spin>
        </div>
      </div>

      <div>
        <span className="title">Latest Month</span>
        <div className="latest">
          <Spin spin={state.loading}>
            <BarChart data={state.barChart} />
          </Spin>
        </div>
      </div>
    </div>
  );
};
